module.exports = __webpack_public_path__ + "img/info_outline.5ca3f99a.svg";